/**
 * The `data-testid` values of a canvas photo's enhancement control in the
 * item toolbar: "Revert changes" while the item shows an accepted
 * enhancement, "Show enhancement" while its photo is reverted.
 * `CanvasEnhancementControl` draws them from here and its tests import them
 * from here.
 */
export const ITEM_ENHANCEMENT_TEST_IDS = {
  REVERT: 'item-enhancement-revert',
  SHOW_ENHANCEMENT: 'item-enhancement-show',
} as const
